import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPsap } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { fetchUser } from '@rsos/sinatra';

const CAPSTONE = 'capstone';

const initialState = {
  initializing: true,
  initialized: false,
  initError: null,
};
const hardRedirect = to => {
  window.location = to;
};

export const initialize = createAsyncThunk(
  'responders/initialize',

  async (args, { dispatch, getState }) => {
    const isLoggedIn = getState().sinatra.user.isLoggedIn;
    return await dispatch(fetchUser())
      .then(res => {
        const foundOrg = res.profile.organizations.find(org => {
          const found = org.roles.find(role => role.application === CAPSTONE);
          return !!found;
        });
        const foundRole = foundOrg.roles.find(
          role => role.application === CAPSTONE,
        );

        if (foundRole.permissions.includes('MANAGE_USERS')) {
          return dispatch(fetchPsap(`/psaps/${foundOrg.name}`));
        } else {
          throw new Error('User does not have permissions to access');
        }
      })
      .catch(err => {
        if (isLoggedIn) {
          if (err) {
            throw new Error(err);
          }
        }
        return hardRedirect('/');
      });
  },
);

const appSlice = createSlice({
  name: 'responders',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(initialize.pending, state => {
        state.initializing = true;
        state.initialized = false;
        state.initError = null;
      })
      .addCase(initialize.fulfilled, state => {
        state.initializing = false;
        state.initialized = true;
        state.initError = null;
      })
      .addCase(initialize.rejected, (state, { error = {} }) => {
        state.initializing = false;
        state.initialized = false;
        state.initError = error.message;
      });
  },
});

export const appReducer = appSlice.reducer;
export default appReducer;
